module.exports = __webpack_public_path__ + "img/Team_DT.496158c3.png";